document.addEventListener("DOMContentLoaded", function () {
  const minusBtns = document.querySelectorAll(".qty-btn.minus");
  const plusBtns = document.querySelectorAll(".qty-btn.plus");
  const qtyInputs = document.querySelectorAll(".qty-input-box");

  minusBtns.forEach((minusBtn, index) => {
    minusBtn.addEventListener("click", function () {
      let currentValue = parseInt(qtyInputs[index].value);
      if (currentValue > parseInt(qtyInputs[index].min)) {
        qtyInputs[index].value = currentValue - 1;
      }
    });
  });

  plusBtns.forEach((plusBtn, index) => {
    plusBtn.addEventListener("click", function () {
      let currentValue = parseInt(qtyInputs[index].value);
      if (currentValue < parseInt(qtyInputs[index].max)) {
        qtyInputs[index].value = currentValue + 1;
      }
    });
  });

  // Add event listeners for add to cart forms
  initializeAddToCartForms();
});

function preventZoom(event) {
  event.preventDefault();
}

function initializeAddToCartForms() {
  // Select all add to cart forms with comprehensive selectors
  const addToCartForms = document.querySelectorAll('form[action*="/cart/add"], form.product-form, .collection-product-card form, .product-card form, form[action="/cart/add"]');
  
  addToCartForms.forEach((form, index) => {
    // Check if we already added our custom listener
    if (form.hasAttribute('data-custom-cart-listener')) {
      return; // Skip if already processed
    }
    // Mark this form as processed
    form.setAttribute('data-custom-cart-listener', 'true');
    
    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      
      // Double check to avoid multiple submissions
      if (form.hasAttribute('data-submitting')) {
        return;
      }
      form.setAttribute('data-submitting', 'true');
      
      const qtyInput = form.querySelector(".qty-input-box");
      const quantity = qtyInput ? parseInt(qtyInput.value) : 1;

      // Check if quantity entered is greater than available quantity
      let currentRealQty = null;
      let realQtyElement = null;
      const card = form.closest(".collection-product-card");
      if (card) {
        realQtyElement = card.querySelector(".real-qty");
        if (realQtyElement) {
          currentRealQty = parseInt(realQtyElement.textContent);
        }
      }

      if (currentRealQty !== null && quantity > currentRealQty) {
        alert("Quantity entered is greater than available quantity");
        form.removeAttribute('data-submitting');
        return false;
      }

      // Change button text to "Adding..."
      const cartBtnText = form.querySelector(".cartbtn-text");
      if (cartBtnText) cartBtnText.textContent = "Adding...";

      const formData = new FormData(form);
      formData.append("quantity", quantity);
      
      try {
        const res = await fetch("/cart/add", {
          method: "POST",
          body: formData,
        });
        
        if (res.ok) {
          // Update real-qty
          if (realQtyElement && currentRealQty !== null) {
            realQtyElement.textContent = currentRealQty - quantity;
          }

          // Update cart drawer (this will handle cart counts and loading animation)
          await window.StickyCart.updateCartDrawer();
          
          // Re-initialize add to cart forms in case new forms were loaded
          initializeAddToCartForms();

          // Change button text back to "Add to Cart"
          if (cartBtnText) cartBtnText.textContent = "Add to Cart";
        } else {
          const errorData = await res.json();
          if (cartBtnText) cartBtnText.textContent = "Add to Cart";
        }
      } catch (err) {
        console.error("Fetch error:", err);
        if (cartBtnText) cartBtnText.textContent = "Add to Cart";
      } finally {
        // Always remove the submitting flag
        form.removeAttribute('data-submitting');
      }
    });
  });
}

// Make initializeAddToCartForms available globally for sticky-cart.js
window.initializeAddToCartForms = initializeAddToCartForms;

document.addEventListener('DOMContentLoaded', function() {
    var labels = document.querySelectorAll('label[for^="Filter-"]');
    labels.forEach(function(label) {
        if (label.htmlFor.includes('availability-1')) {
            label.innerHTML = label.innerHTML.replace('In stock', '有存貨');
        } else if (label.htmlFor.includes('availability-2')) {
            label.innerHTML = label.innerHTML.replace('Out of stock', '無存貨');
        }
    });
});